export default "/images/shopping-cart.svg?33ce5d1587bf4a7a971bb64d9418e125";